import { render, staticRenderFns } from "./UserOnboardView.vue?vue&type=template&id=15bce5de&scoped=true"
import script from "./UserOnboardView.vue?vue&type=script&lang=js"
export * from "./UserOnboardView.vue?vue&type=script&lang=js"
import style0 from "./UserOnboardView.vue?vue&type=style&index=0&id=15bce5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bce5de",
  null
  
)

export default component.exports